


















import Vue from 'vue'

import { client } from '@/services/ApiClient'

const randomString = (): string =>
  Math.random()
    .toString(36)
    .substring(2, 15) +
  Math.random()
    .toString(36)
    .substring(2, 15)

export default Vue.extend({
  name: 'Login',
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (!vm.$root.$data.isLoggedIn) {
        try {
          vm.$root.$data.user = await client.whoAmI()
          vm.$root.$data.isLoggedIn = true
        } catch (e) {
          // ignore
          return
        }
      }

      // noinspection ES6MissingAwait
      vm.$router.replace({ path: '/' })
    })
  },
  methods: {
    loginViaGoogle() {
      const state = `${window.location.host} ${randomString()}`
      document.cookie = `auth-state=${state};max-age=60;path=/`
      const redirect = encodeURIComponent(`${process.env.VUE_APP_BASE_URL}auth/callback`)
      const urlParts = [
        'https://accounts.google.com/o/oauth2/v2/auth?scope=openid email profile',
        `nonce=${randomString()}`,
        'response_type=id_token',
        'hd=sclable.com',
        `state=${state}`,
        `redirect_uri=${redirect}`,
        `client_id=${process.env.VUE_APP_CLIENT_ID}`,
      ]

      window.location.href = urlParts.join('&')
    },
  },
})
